import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './scss/index.scss'
import './utils/dateUtil'

import VideoPlayer from 'vue-video-player' // video
import md5 from 'js-md5'
import VueClipboard from 'vue-clipboard2'
import '../src/fonts/style.css'
import waterfall from 'vue-waterfall2'
import config from '@/config'
// 无限滚动加载
import InfiniteLoading from 'vue-infinite-loading'
import {formatDate, formatFileSize, formatNumber, getFileType, thousands} from './utils/utils'
import inputNumber from '@/components/form/input-number'
import {getFomatUrl} from './utils/picFormatUtil'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('videojs-contrib-hls')


Vue.prototype.$md5 = md5
Vue.prototype.$config = config
Vue.prototype.$formatFileSize = formatFileSize
Vue.prototype.$getFileType = getFileType
Vue.prototype.$formatDate = formatDate
Vue.prototype.$formatNumber = formatNumber
Vue.prototype.$thousands = thousands
Vue.prototype.$getFomatUrl = getFomatUrl
Vue.config.productionTip = false
Vue.use(InfiniteLoading)
Vue.use(ViewUI)
Vue.use(VideoPlayer)
Vue.use(VueClipboard)
Vue.use(waterfall)
Vue.component('inputNumber', inputNumber)

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


Vue.directive('resize', {
  bind (el, binding) {
    // el为绑定的元素，binding为绑定给指令的对象
    // console.log(el, '绑定', binding)
    let width = '', height = ''

    function isReize () {
      const style = document.defaultView.getComputedStyle(el)
      if (width !== style.width || height !== style.height) {
        // 关键(这传入的是函数,所以执行此函数)
        binding.value({width: style.width.replace('px', ''), height: style.height.replace('px', '')})
      }
      width = style.width
      height = style.height
    }

    el.__vueSetInterval__ = setInterval(isReize, 100)
  },

  unbind (el) {
    // console.log(el, '解绑')
    clearInterval(el.__vueSetInterval__)
  }
})

export default vue
